import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getArticles(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`articles` + (page ? range : ''))
    },

    getFilteredArticles(filter, page, size, sort) {
        return api.get(`articles` + buildListQuery({ filter, page, size, sort }))
    },

    getArticle(id) {
        return api.get(`articles/${id}`)
    },

    createArticle(data) {
        return api.post('articles', data)
    },

    updateArticle(id, data) {
        return api.put(`articles/${id}`, data)
    },

    delete(id) {
        return api.delete(`articles/${id}`)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/articles', formData)
    }
}
